var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86435",
    "data-name": "Group 86435",
    transform: "translate(23724.5 22885.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-23727.5 -22888.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242644",
    "data-name": "Path 242644",
    d: "M28.5,33H7.5A4.505,4.505,0,0,1,3,28.5v-6a1.5,1.5,0,0,1,3,0v6A1.5,1.5,0,0,0,7.5,30h21A1.5,1.5,0,0,0,30,28.5v-6a1.5,1.5,0,0,1,3,0v6A4.505,4.505,0,0,1,28.5,33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242645",
    "data-name": "Path 242645",
    d: "M18,24a1.5,1.5,0,0,1-1.061-.439l-7.5-7.5a1.5,1.5,0,0,1,2.121-2.121L18,20.379l6.439-6.439a1.5,1.5,0,0,1,2.121,2.121l-7.5,7.5A1.5,1.5,0,0,1,18,24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242646",
    "data-name": "Path 242646",
    d: "M18,24a1.5,1.5,0,0,1-1.5-1.5V4.5a1.5,1.5,0,0,1,3,0v18A1.5,1.5,0,0,1,18,24Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.1ddab81016e21b927bd73c7304be77bd.svg";
export { ForwardRef as ReactComponent };